import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()

export class PreloaderService {
    loader: any;
    PreloaderSubject = new BehaviorSubject<any>(this.loaderStatus());

    constructor() {
    }

    private loaderStatus(): boolean {
        return !!this.loader;
    }

    getLoader() {
        return this.PreloaderSubject.asObservable();
    }

    loaderState(loader: boolean) {
        this.loader = loader;
        this.PreloaderSubject.next(loader);
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/services/preloader.service.ts